var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.certificatemasterid||_vm.certificaruleid)?_c('div',[_c('Vip',{attrs:{"certificatemasterid":_vm.certificatemasterid,"certificaruleid":_vm.certificaruleid}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }